import React from 'react'
import PropTypes from 'prop-types';

import { Button, Col, Row } from "react-bootstrap";
import { fetchServer } from "../Base/modelManager";
import { message } from 'antd';




class PaiementForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: null,
            loading: false
        }
    }


    onCancel = () => {
        this.props.onCancel()
    }

    onSubmit = (e) => {
        e.preventDefault()

        let paiementDataUrl = ''
        if (this.props.envID === 'btf')
            paiementDataUrl = 'getPaiementData'
        else if (this.props.envID === 'autogestion')
            paiementDataUrl = 'getMoneticoPaiementData'

        if (paiementDataUrl === '') {
            message.error('Cet environnement ne dispose par d\'interface de paiement', 10)
            return
        }

        if (!this.state.loading) {
            this.setState({ loading: true })
            const request = {
                endPoint: this.props.apiUrl + '/services/' + paiementDataUrl + '?factureid=' + this.props.facture.id,
                method: 'GET',
                token: this.props.JWTToken
            }

            fetchServer(request, (json) => {



                var mapForm = document.createElement("form");

                mapForm.target = '_self';
                mapForm.method = "POST";
                if (this.props.envID === 'btf')
                    mapForm.action = "https://sogecommerce.societegenerale.eu/vads-payment/"
                else if (this.props.envID === 'autogestion')
                    mapForm.action = json.url


                Object.keys(json).forEach(item => {
                    if (((this.props.envID === 'btf') && ((item === 'signature' || item.startsWith('vads')))) || ((this.props.envID === 'autogestion') && (item !== '$id')&& (item !== '@xdata.type')&& (item !== 'url'))) {
                        var mapInput = document.createElement("input");
                        mapInput.type = "hidden";
                        mapInput.name = item;
                        mapInput.value = json[item];
                        mapForm.appendChild(mapInput);

                    }
                })


                document.body.appendChild(mapForm);
                if (this.props.envID !== 'autogestion')
                    mapForm.submit();


            }, this.onError)
        }
    }


    onError = (error) => {
        message.error(error)
    }


    render() {

        const { data } = this.state

        if (data === null) {
            return (
                <div className="formPaiement">

                    <p>Vous êtes sur le point de solder votre Facture</p>
                    <p>{this.props.facture.periode.libelle}</p>
                    <p>Solde={this.props.facture.solde}</p>
                    <p>En cliquant sur le Bouton "Payer" vous serez rediriger vers le site de paiement securisé</p>

                    <Row>
                        <Col></Col>
                        <Col>
                            <Button onClick={this.onCancel}>Annuler</Button>
                        </Col>
                        <Col></Col>
                        <Col>
                            <Button onClick={this.onSubmit}>Payer</Button>
                        </Col>
                        <Col></Col>
                    </Row>


                </div>
            )
        }



        /*
      <input name='signature' defaultValue={data.signature} hidden />
                    <input name='vads_action_mode' defaultValue={data.vads_action_mode} hidden />
                    <input name='vads_amount' defaultValue={data.vads_amount} hidden />
                    <input name='vads_ctx_mode' defaultValue={data.vads_ctx_mode} hidden />
                    <input name='vads_currency' defaultValue={data.vads_currency} hidden />
                    <input name='vads_order_id' defaultValue={data.vads_order_id} hidden />
                    <input name='vads_order_info' defaultValue={data.vads_order_info} hidden />
                    <input name='vads_page_action' defaultValue={data.vads_page_action} hidden />
                    <input name='vads_payment_config' defaultValue={data.vads_payment_config} hidden />
                    <input name='vads_site_id' defaultValue={data.vads_site_id} hidden />
                    <input name='vads_trans_date' defaultValue={data.vads_trans_date} hidden />
                    <input name='vads_trans_id' defaultValue={data.vads_trans_id} hidden />
                    <input name='vads_version' defaultValue={data.vads_version} hidden />
                    */




    }
}

PaiementForm.propTypes = {
    facture: PropTypes.object,
    apiUrl: PropTypes.string,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    onClose: PropTypes.func
};



export default PaiementForm
